/**
 * {@link https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#mask-array}
 */
export type PrizmTextMaskList = ReadonlyArray<string | RegExp>;
